// This import is okay because it's the proxy
// eslint-disable-next-line no-restricted-imports
import type { Headers } from '@engage/graphql/client';
// eslint-disable-next-line no-restricted-imports
import { toClient as engageToClient } from '@engage/graphql/client';
import { engageApi } from '@members/data-fetch/singletons';
import { getUatApiOverrides } from '@members/env/api';

export const toClient = (headers?: Headers, getAuthHeader?: () => Promise<string>) =>
  engageToClient(engageApi, headers, getUatApiOverrides, getAuthHeader);
